export const TIPOS_CLIENTE = ["Venezolano", "Extranjero", "Jurídico"]

export const UNIDADES = {
  unid: "Unidades",
  cm: "Centímetros",
  mt: "Metros",
  km: "Kilómetros",
  g: "Gramos",
  mg: "Miligramos",
  kg: "Kilogramos",
  ton: "Toneladas",
  ml: "Mililitros",
  lt: "Litros",
  caja: "Caja",
  paq: "Empaq.",
}

export const DIAS = [7, 10, 15]

export const MAX_CANTIDAD_PRODUCTO = 99999.99

export const TIPOS_PAGO_SIMPLE = {
  punto: "Punto de Venta",
  dolar: "Efectivo ($)",
  Credito: "Credito",
}

export const TIPOS_PAGO_CRUD = {
  pagomovil: "Pago Móvil",
  transferencia: "Transferencia",
  zelle: "Zelle",
  binance: "Binance",
}

export const TIPOS_PAGO = {
  ...TIPOS_PAGO_SIMPLE,
  ...TIPOS_PAGO_CRUD,
}

export const BANCOS = [
  "BANCAMIGA",
  "BANCARIBE",
  "BANCO ACTIVO",
  "BANCO AGRICOLA",
  "BANCO CARONI",
  "BANCO DE VENEZUELA",
  "BANCO DEL CARIBE",
  "BANCO DEL SUR",
  "BANCO DEL TESORO",
  "BANCO DIGITAL DE LOS TRABAJDORES",
  "BANCO EXTERIOR",
  "BANCO MERCANTIL",
  "BANCO PLAZA",
  "BANCO PROVINCIAL",
  "BANCRECER",
  "BANESCO",
  "BANFANB",
  "BANGENTE",
  "BANPLUS",
  "BFC",
  "MI BANCO",
  "NACIONAL DE CREDITO",
  "SOFITASA",
  "VENEZOLANO DE CREDITO",
  "100 X 100 BANCO",
]

// Mapa `name de ruta` -> permiso que exige la guarda global de src/router/index.js.
//
// OJO: la clave DEBE coincidir exactamente con el `name` declarado en el router.
// Si no coincide, la guarda ignora la ruta y esta queda SIN control de acceso.
//
// Rutas sin entrada a proposito (acceso libre con sesion iniciada):
// InicioComponent, InicioSesionComponent, PerfilComponent, CambiarPassword.
//
// "vistas.vender" es un permiso derivado que calcula AyudanteSesion a partir de
// ventas.registrar_venta / _cuenta / _apartado / _cotiza; no vive en la BD.
export const PERMISOS_RUTAS = {
  // Inventario y almacenes
  ProductosComponent: "vistas.inventario",
  AgregarProducto: "productos.registrar",
  EditarProducto: "productos.editar",
  MarcasCategorias: "vistas.marcas_categorias",
  AlmacenesComponent: "vistas.almacenes",
  AgregarAlmacen: "almacenes.registrar",
  EditarAlmacen: "almacenes.editar",
  ReconciliacionInventario: "productos.agregar_existencia",

  // Ventas, cuentas, apartados, abonos
  RealizarVenta: "vistas.vender",
  ReporteVentas: "vistas.ventas",
  EditarVenta: "ventas.actualizar_venta",
  ReporteCuentas: "vistas.cuentas",
  EditarCuenta: "ventas.actualizar_cuenta",
  ReporteApartados: "vistas.apartados",
  ReporteCotizaciones: "vistas.cotizaciones",
  AbonosComponent: "vistas.abonos",
  RealizarAbono: "ventas.realizar_abono",
  EditarAbono: "ventas.actualizar_abono",

  // Entregas y choferes
  DeliveriesComponent: "vistas.deliveries",
  ChoferesComponent: "vistas.choferes",
  EditarChofer: "choferes.editar",

  // Movimientos y cierres
  HistorialComponent: "vistas.historial",
  CierresComponent: "vistas.cierres",

  // Proveedores y pagos
  ProveedoresComponent: "vistas.proveedores",
  AgregarProveedor: "proveedores.registrar",
  EditarProveedor: "proveedores.editar",
  PagosComponent: "vistas.pagos",
  RealizarPago: "proveedores.pagar_proveedor",

  // Clientes
  ClientesComponent: "vistas.clientes",
  AgregarCliente: "clientes.registrar",
  EditarCliente: "clientes.editar",

  // Configuracion
  MetodosComponent: "vistas.metodos",
  AgregarMetodo: "metodos.registrar",
  EditarMetodo: "metodos.editar",
  UsuariosComponent: "vistas.usuarios",
  AgregarUsuario: "usuarios.registrar",
  EditarUsuario: "usuarios.editar",
  RolesComponent: "vistas.roles",
  AgregarRol: "roles.registrar",
  EditarRol: "roles.editar",

  // Reportes PDF: heredan el permiso de la vista de la que salen
  PDFVentas: "vistas.ventas",
  PDFCuentas: "vistas.cuentas",
  PDFApartados: "vistas.apartados",
  PDFCotizaciones: "vistas.cotizaciones",
  PDFProductos: "vistas.inventario",
  PDFClientes: "vistas.clientes",
  PDFChoferes: "vistas.choferes",
  PDFMovimientos: "vistas.historial",
  PDFAbonos: "vistas.abonos",
  PDFTodosAbonos: "vistas.abonos",
  PDFAbono: "vistas.abonos",
  PDFDeliveries: "vistas.deliveries",
  PDFCierres: "vistas.cierres",
}

export const PERMISOS = {
  "vistas.marcas_categorias": "Ver marcas y categorías",
  "marcas.registrar": "Registrar marca",
  "marcas.editar": "Editar marca",
  "marcas.eliminar": "Eliminar marca",
  "categorias.registrar": "Registrar categoría",
  "categorias.editar": "Editar categoría",
  "categorias.eliminar": "Eliminar categoría",
  "vistas.choferes": "Ver choferes",
  "choferes.editar": "Editar chofer",
  "choferes.pagar_chofer": "Registrar pago a chofer",
  "vistas.deliveries": "Ver deliveries",
  "vistas.clientes": "Ver clientes",
  "clientes.registrar": "Registrar cliente",
  "clientes.editar": "Editar cliente",
  "clientes.eliminar": "Eliminar cliente",
  "vistas.metodos": "Ver métodos de pago",
  "metodos.registrar": "Registrar método de pago",
  "metodos.editar": "Editar método de pago",
  "metodos.eliminar": "Eliminar método de pago",
  "vistas.inventario": "Ver productos",
  "productos.registrar": "Registrar producto",
  "productos.editar": "Editar producto",
  "productos.eliminar": "Eliminar producto",
  "productos.obtener_nombre_codigo": "Buscar producto por nombre o código",
  "productos.agregar_existencia": "Agregar existencia",
  "productos.remover_existencia": "Retirar existencia",
  "vistas.proveedores": "Ver proveedores",
  "proveedores.registrar": "Registrar proveedor",
  "proveedores.editar": "Editar proveedor",
  "vistas.pagos": "Ver pagos a proveedores",
  "proveedores.pagar_proveedor": "Registrar pago a proveedor",
  "vistas.roles": "Ver roles",
  "roles.registrar": "Registrar rol",
  "roles.editar": "Editar rol",
  "vistas.usuarios": "Ver usuarios",
  "usuarios.registrar": "Registrar usuario",
  "usuarios.editar": "Editar usuario",
  "usuarios.eliminar": "Eliminar usuario",
  "vistas.ventas": "Ver ventas",
  "ventas.registrar_venta": "Registrar venta",
  "vistas.cuentas": "Ver cuentas",
  "ventas.registrar_cuenta": "Registrar cuenta",
  "vistas.apartados": "Ver apartados",
  "ventas.registrar_apartado": "Registrar apartado",
  "vistas.cotizaciones": "Ver cotizaciones",
  "ventas.registrar_cotiza": "Registrar cotización",
  "ventas.eliminar_cotiza": "Eliminar cotizacion",
  "vistas.abonos": "Ver abonos",
  "ventas.realizar_abono": "Registrar abono",
  "vistas.historial": "Ver movimientos",
  // Edición y borrado de documentos. Las etiquetas usan el nombre REAL de la acción del
  // API (auth.php valida {archivo}.{accion}): antes el formulario ofrecía "Editar venta"
  // con la clave `ventas.editar`, mientras el endpoint que edita es
  // `ventas.actualizar_venta`; el checkbox no protegía nada. Ahora son la misma clave.
  "ventas.actualizar_venta": "Editar venta",
  "ventas.eliminar_venta": "Eliminar venta",
  "ventas.actualizar_cuenta": "Editar cuenta o apartado",
  "ventas.eliminar_cuenta": "Eliminar cuenta o apartado",
  "ventas.actualizar_abono": "Editar abono",
  "ventas.eliminar_abono": "Eliminar abono",
  "ventas.auditoria_abonos": "Auditar abonos duplicados",
  "clientes.reactivar": "Reactivar cliente eliminado",
  "clientes.obtener_ocultos": "Ver clientes eliminados",
  "choferes.registrar": "Registrar chofer",
  "productos.reactivar": "Reactivar producto eliminado",
  "productos.obtener_ocultos": "Ver productos eliminados",
  "productos.agregar_paquete": "Vincular producto empaquetado a un producto",
  "productos.editar_paquete": "Corregir vinculación de producto empaquetado",
  "productos.eliminar_paquete": "Desvincular producto empaquetado",
  "productos.reconciliar": "Reconciliar inventario (conteo físico)",
  "productos.auditoria_paquetes": "Auditar vinculaciones de productos empaquetados",
  "usuarios.obtener": "Listar usuarios",
  "usuarios.obtener_por_id": "Ver ficha de usuario",
  "roles.obtener": "Listar roles",
  "roles.obtener_por_id": "Ver ficha de rol",
  "roles.auditoria_permisos": "Auditar permisos del sistema",
  "vistas.cierres": "Ver cierres de caja",
  "vistas.almacenes": "Ver almacenes",
  "almacenes.registrar": "Registrar almacén",
  "almacenes.editar": "Editar almacén",
  "almacenes.eliminar": "Eliminar almacén",
}
